import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MainService } from '../../../services/main/main.service';
import { ExcelService } from '../../../services/excel/excel.service';

@Component({
  selector: 'app-payment-reports',
  templateUrl: './payment-reports.component.html',
  styleUrls: ['./payment-reports.component.scss']
})
export class PaymentReportsComponent implements OnInit {
  queryParamSubscription: any;
  token: any;
  mode: any;
  startDate: any;
  endDate: any;
  payoutList: any;
  doctorInfo: any;
  financeContracts: any;
  list: any[];
  language_preferred: any;

  constructor(private route: ActivatedRoute,
    private mainService: MainService,
    private excelService: ExcelService) {
    this.queryParamSubscription = this.route.queryParams.subscribe(params => {
      if (params && params.ac_tk) {
        this.token = params.ac_tk;
        this.mode = params.mode;
        this.startDate = params.sd;
        this.endDate = params.ed;
        this.language_preferred = params.lang
      }
      if (this.mode == 'contracts') {
        this.getContractsReport(this.token, this.startDate, this.endDate);
      }
    });
  }

  ngOnInit(): void {

  }

  getPaymentReports(token, start, end, val?) {
    let data = {
      access_token: token,
      start_date: start,
      end_date: end
    }
    var p;
    this.mainService.api(data, `payment_reports`, false, 'object').subscribe(data => {
      if (data.is_error == 0) {
        let report = data;
        var s_d = data.start_date.split('-');
        var e_d = data.end_date.split('-');
        this.doctorInfo = report.doctor_info
        let totalDownpayment = data.total_downpayment ? data.total_downpayment : 0;
        let totalRecurring = data.total_recurring ? data.total_recurring : 0;
        let totalPayment = data.total_payout_amount ? data.total_payout_amount : 0;
        report.start_temp = new Date(s_d[0], parseInt(s_d[1]) - 1, s_d[2]);
        report.end_temp = new Date(e_d[0], parseInt(e_d[1]) - 1, e_d[2]);
        for (var x = 0; x < data.payouts.length; x++) {
          p = data.payouts[x];
          var a = p.arrival_date.split("-");
          p.arrival_date = a[1] + '-' + a[2] + '-' + a[0];
          for (var y = 0; y < p.payments.length; y++) {
            if (!p.payments[y].transaction_created) {
              p.payments[y].transaction_created = '-';
            } else {
              var t = p.payments[y].transaction_created.split("-");
              p.payments[y].transaction_created = t[1] + '-' + t[2] + '-' + t[0];
            }
          }
        }
        this.payoutList = [];
        this.payoutList[0] = {
          a: 'Start Date',
          b: 'End Date',
          c: 'Name',
          d: 'Business Name',
          e: 'Email Address',
          f: 'Phone Number',
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[1] = {
          a: this.startDate,
          b: this.endDate,
          c: (this.doctorInfo.title ? this.doctorInfo.title + ' ' : '') + this.doctorInfo.doctor_first_name + this.doctorInfo.doctor_last_name,
          d: this.doctorInfo.practice_name || this.doctorInfo.is_doctor_agent ? (this.doctorInfo.practice_name || '') : '-',
          e: this.doctorInfo.doctor_email || '-',
          f: this.doctorInfo.doctor_mobile || '-',
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[2] = {
          a: '',
          b: '',
          c: '',
          d: '',
          e: '',
          f: '',
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[3] = {
          a: '',
          b: 'Recurring Payment',
          c: '',
          d: 'Down Payment',
          e: '',
          f: 'Total Payment',
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[4] = {
          a: '',
          b: '$' + parseFloat(totalRecurring).toFixed(2) + (report.payouts && report.payouts[0] && report.payouts[0].currency == 'cad' ? ' CAD' : ''),
          c: '',
          d: '$' + parseFloat(totalDownpayment).toFixed(2) + (report.payouts && report.payouts[0] && report.payouts[0].currency == 'cad' ? ' CAD' : ''),
          e: '',
          f: '$' + parseFloat(totalPayment).toFixed(2) + (report.payouts && report.payouts[0] && report.payouts[0].currency == 'cad' ? ' CAD' : ''),
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[5] = {
          a: '',
          b: '',
          c: '',
          d: '',
          e: '',
          f: '',
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[6] = {
          a: '',
          b: '',
          c: 'Payout Details',
          d: '',
          e: '',
          f: '',
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[7] = {
          a: '',
          b: '',
          c: '',
          d: '',
          e: '',
          f: '',
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[8] = {
          a: 'Payout Date',
          b: 'Amount',
          c: 'Contract ID \n (Status)',
          d: 'Customer Name',
          e: 'Customer Refernce Number',
          f: 'Email Address',
          g: 'Transaction Date',
          h: 'Payment Type',
          i: 'Total Payment'
        };
        var c = 9;
        for (var j = 0; j < report.payouts.length; j++) {
          var filter_payouts = report.payouts[j].payments;
          for (var i = 0; i < filter_payouts.length; i++) {
            this.payoutList[c] = {};
            if (i == 0) {
              this.payoutList[c].a = report.payouts[j].arrival_date;
              this.payoutList[c].b = '$' + report.payouts[j].amount.toFixed(2) + (report.payouts[j].currency == 'cad' ? ' CAD' : '') + '\n';
            } else {
              this.payoutList[c].a = '';
              this.payoutList[c].b = '';
            }
            this.payoutList[c].c = filter_payouts[i].contract_code ? filter_payouts[i].contract_status ? (filter_payouts[i].contract_code + '\n(' + filter_payouts[i].contract_status + ')') : filter_payouts[i].contract_code : '-';
            this.payoutList[c].d = filter_payouts[i].patient_name ? filter_payouts[i].title ? filter_payouts[i].title + '' : '' + filter_payouts[i].patient_name || filter_payouts[i].patient_name : '-';
            this.payoutList[c].e = filter_payouts[i].doctor_record_id || '-';
            this.payoutList[c].f = filter_payouts[i].patient_email || '-';
            this.payoutList[c].g = filter_payouts[i].transaction_created || '-';
            this.payoutList[c].h = filter_payouts[i].payment_type || '-';
            this.payoutList[c].i = '$' + parseFloat(filter_payouts[i].pay_to_doctor || 0).toFixed(2) + (filter_payouts[i].currency == 'cad' ? ' CAD' : '') || '-';
            c++;
          }
        }
        if (val && val == 1) {
          this.excelService.exportAsExcelFile(this.payoutList, "PayoutReport", '.xlsx');
        }
      } else {
        this.mainService.customPopups('Error.', 1);
      }
    });
  }

  getContractsReport(token, start, end, val?) {
    let data = {
      access_token: token,
      start_date: start,
      end_date: end
    }

    this.mainService.api(data, `contract_reports`, false, 'object').subscribe(data => {
      if (data.is_error == 0) {
        var i;
        this.financeContracts = data.contracts;
        this.list = [];
        this.list[0] = {
          contract_id: 'Contract ID',
          patient_name: 'Customer' + ' Name',
          patient_email: 'Customer' + ' Email',
          patient_mobile: 'Customer' + ' Mobile',
          patient_address: 'Customer' + ' Address',
          date_added: 'Enrollment Date',
          financed_amount: 'Estimated Payment Plan Amount($)',
          treatment_amount: 'Estimated ' + 'Customer' + ' Amount($)',
          number_of_payments: 'Number of Payments',
          recurring_amount: 'Recurring Payment($)',
          downpayment_amount: 'Down Payment Amount($)',
          interest_rate: 'Interest Rate(%)',
          interest_amount: 'Interest Amount($)',
          contract_status: 'Contract Status',
          next_payment_date: 'Next Recurring Payment Date'
        };
        for (i = 0; i < this.financeContracts.length; i++) {
          var dA = this.financeContracts[i].date_added.split(" ");
          var dD = dA[0].split("-");
          this.financeContracts[i].date_added = dD[1] + '-' + dD[2] + '-' + dD[0];
          this.financeContracts[i].interest_amount = ((this.financeContracts[i].recurring_amount * this.financeContracts[i].number_of_payments) - this.financeContracts[i].financed_amount).toFixed(2);
          this.financeContracts[i].interest_amount = this.financeContracts[i].interest_amount > 0 ? this.financeContracts[i].interest_amount : 0;
          if (this.financeContracts[i].next_payment_date) {
            var temp = this.financeContracts[i].next_payment_date.split("-");
            this.financeContracts[i].next_payment_date = temp[1] + '-' + temp[2] + '-' + temp[0];
          } else {
            this.financeContracts[i].next_payment_date = 'Not Applicable'
          }
          this.list[i + 1] = {};
          this.list[i + 1].contract_id = this.financeContracts[i].contract_code;
          this.list[i + 1].patient_name = (this.financeContracts[i].patient_title ? this.financeContracts[i].patient_title + ' ' : '') + this.financeContracts[i].patient_name;
          this.list[i + 1].patient_email = this.financeContracts[i].patient_email;
          this.list[i + 1].patient_mobile = this.financeContracts[i].patient_mobile;
          this.list[i + 1].patient_address = this.financeContracts[i].patient_address;
          this.list[i + 1].date_added = this.financeContracts[i].date_added;
          this.list[i + 1].financed_amount = this.financeContracts[i].financed_amount;
          this.list[i + 1].treatment_amount = this.financeContracts[i].treatment_amount;
          this.list[i + 1].number_of_payments = this.financeContracts[i].number_of_payments;
          this.list[i + 1].recurring_amount = this.financeContracts[i].recurring_amount;
          this.list[i + 1].downpayment_amount = this.financeContracts[i].downpayment_amount;
          this.list[i + 1].interest_rate = this.financeContracts[i].interest_rate_to_show;
          this.list[i + 1].interest_amount = this.financeContracts[i].interest_amount;
          this.list[i + 1].contract_status = this.financeContracts[i].contract_status;
          this.list[i + 1].next_payment_date = this.list[i + 1].contract_status == 'Completed' ? 'Not applicable' : this.financeContracts[i].next_payment_date;
        }
        if (val && val == 2) {
          this.excelService.exportAsExcelFile(this.list, 'Contract-report', '.xlsx');
        }
      } else {
        this.mainService.customPopups('Error.', 1);
      }
    });
  }

  getPaymentReportsV2(token, start, end, val?) {
    let data = {
      access_token: token,
      start_date: start,
      end_date: end
    }
    var p;
    this.mainService.api(data, `payment_reports_v2`, false, 'object').subscribe(data => {
      if (data.is_error == 0) {
        let report = data;
        var s_d = data.start_date.split('-');
        var e_d = data.end_date.split('-');
        this.doctorInfo = report.doctor_info
        let totalDownpayment = data.total_downpayment ? data.total_downpayment : 0;
        let totalRecurring = data.total_recurring ? data.total_recurring : 0;
        let totalPayment = data.total_payout_amount ? data.total_payout_amount : 0;
        report.start_temp = new Date(s_d[0], parseInt(s_d[1]) - 1, s_d[2]);
        report.end_temp = new Date(e_d[0], parseInt(e_d[1]) - 1, e_d[2]);
        for (var x = 0; x < data.payouts.length; x++) {
          p = data.payouts[x];
          var a = p.arrival_date.split("-");
          p.arrival_date = a[1] + '-' + a[2] + '-' + a[0];
          for (var y = 0; y < p.payments.length; y++) {
            if (!p.payments[y].transaction_created) {
              p.payments[y].transaction_created = '-';
            } else {
              var t = p.payments[y].transaction_created.split("-");
              p.payments[y].transaction_created = t[1] + '-' + t[2] + '-' + t[0];
            }
          }
        }
        this.payoutList = [];
        this.payoutList[0] = {
          a: 'Start Date',
          b: 'End Date',
          c: 'Name',
          d: 'Business Name',
          e: 'Email Address',
          f: 'Phone Number',
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[1] = {
          a: this.startDate,
          b: this.endDate,
          c: (this.doctorInfo.doctor_name || ''),
          d: this.doctorInfo.practice_name || this.doctorInfo.is_doctor_agent ? (this.doctorInfo.practice_name || '') : '-',
          e: this.doctorInfo.doctor_email || '-',
          f: this.doctorInfo.doctor_mobile || '-',
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[2] = {
          a: '',
          b: '',
          c: '',
          d: '',
          e: '',
          f: '',
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[3] = {
          a: '',
          b: 'Recurring Payment',
          c: '',
          d: 'Down Payment',
          e: '',
          f: 'Total Payment',
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[4] = {
          a: '',
          b: '$' + parseFloat(totalRecurring).toFixed(2) + (report.payouts && report.payouts[0] && report.payouts[0].currency == 'cad' ? ' CAD' : ''),
          c: '',
          d: '$' + parseFloat(totalDownpayment).toFixed(2) + (report.payouts && report.payouts[0] && report.payouts[0].currency == 'cad' ? ' CAD' : ''),
          e: '',
          f: '$' + parseFloat(totalPayment).toFixed(2) + (report.payouts && report.payouts[0] && report.payouts[0].currency == 'cad' ? ' CAD' : ''),
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[5] = {
          a: '',
          b: '',
          c: '',
          d: '',
          e: '',
          f: '',
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[6] = {
          a: '',
          b: '',
          c: 'Payout Details',
          d: '',
          e: '',
          f: '',
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[7] = {
          a: '',
          b: '',
          c: '',
          d: '',
          e: '',
          f: '',
          g: '',
          h: '',
          i: ''
        };
        this.payoutList[8] = {
          a: 'Payout Date',
          b: 'Amount',
          c: 'Contract ID \n (Status)',
          d: 'Customer Name',
          e: 'Customer Refernce Number',
          f: 'Email Address',
          g: 'Transaction Date',
          h: 'Payment Type',
          i: 'Total Payment'
        };
        if(report && report.doctor_info && report.doctor_info.show_instant_adjustment && report.doctor_info.show_instant_adjustment == 1){
          this.payoutList[8].j = 'Instant Payout';
          this.payoutList[8].k = 'Adjust Instant Payout Amount';
        }
        var c = 9;
        for (var j = 0; j < report.payouts.length; j++) {
          if(report.payouts[j].instant_payout_by_business == 0){
            var filter_payouts = report.payouts[j].payments;
            for (var i = 0; i < filter_payouts.length; i++) {
              if (isNaN(filter_payouts[i].amount_to_show) || filter_payouts[i].amount_to_show === '-') {
                filter_payouts[i].transaction_created = report.payouts[j].arrival_date;
                filter_payouts[i].amount_to_show = report.payouts[j].amount;
              }
              this.payoutList[c] = {};
              if (i == 0) {
                this.payoutList[c].a = report.payouts[j].arrival_date;
                this.payoutList[c].b = '$' + report.payouts[j].amount.toFixed(2) + (report.payouts[j].currency == 'cad' ? ' CAD' : '') + '\n';
              } else {
                this.payoutList[c].a = '';
                this.payoutList[c].b = '';
              }
              this.payoutList[c].c = filter_payouts[i].contract_code ? filter_payouts[i].contract_status ? (filter_payouts[i].contract_code + '\n(' + filter_payouts[i].contract_status + ')') : filter_payouts[i].contract_code : '-';
              this.payoutList[c].d = filter_payouts[i].patient_name ? filter_payouts[i].title ? filter_payouts[i].title + '' : '' + filter_payouts[i].patient_name || filter_payouts[i].patient_name : '-';
              this.payoutList[c].e = filter_payouts[i].doctor_record_id || '-';
              this.payoutList[c].f = filter_payouts[i].patient_email || '-';
              this.payoutList[c].g = filter_payouts[i].transaction_created || '-';
              this.payoutList[c].h = filter_payouts[i].payment_type || '-';
              if (filter_payouts[i].amount_to_show != 0) {
                const amount = parseFloat(filter_payouts[i].amount_to_show) || 0;
                const formatted = (amount < 0 ? '-$' : '$') + Math.abs(amount).toFixed(2) + (filter_payouts[i].currency == 'cad' ? ' CAD' : '');
                this.payoutList[c].i = formatted;
              } else {
                this.payoutList[c].i = '-';
              }
              if(report && report.doctor_info && report.doctor_info.show_instant_adjustment && report.doctor_info.show_instant_adjustment == 1){
                this.payoutList[c].j = (filter_payouts[i].instant_payout_type == 1) ? 'Fully Adjusted' : (filter_payouts[i].instant_payout_type == 2) ? 'Partially Adjusted' : '-';
                this.payoutList[c].k = (filter_payouts[i].adjust_instant_payout_amount > 0) ? '$'+filter_payouts[i].adjust_instant_payout_amount : '-';
              }
              c++;
            }
          } else {
              this.payoutList[c] = {};
              this.payoutList[c].a = report.payouts[j].arrival_date;
              this.payoutList[c].b = '$' + report.payouts[j].amount.toFixed(2) + (report.payouts[j].currency == 'cad' ? ' CAD' : '') + '\n';
              this.payoutList[c].c = '-'
              this.payoutList[c].d = '-'
              this.payoutList[c].e = '-'
              this.payoutList[c].f = '-'
              this.payoutList[c].g = report.payouts[j].arrival_date;
              this.payoutList[c].h = report.payouts[j].payment_type || '-';
              this.payoutList[c].i = '$' + report.payouts[j].amount.toFixed(2) + (report.payouts[j].currency == 'cad' ? ' CAD' : '') + '\n';
              if(report && report.doctor_info && report.doctor_info.show_instant_adjustment && report.doctor_info.show_instant_adjustment == 1){
                this.payoutList[c].j = '-';
                this.payoutList[c].k = '-';
              }
              c++;
          }
        }
        if (val && val == 1) {
          this.excelService.exportAsExcelFile(this.payoutList, "PayoutReport", '.xlsx');
        }
      } else {
        this.mainService.customPopups('Error.', 1);
      }
    });
  }

}
